import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ShieldCheckIcon } from '@heroicons/react/24/solid';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

  // Function to handle navigation with scroll to top
  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <button 
              onClick={() => handleNavigate('/')} 
              className="flex items-center space-x-2 mb-4 hover:opacity-80 transition-opacity"
            >
              <ShieldCheckIcon className="h-6 w-6 text-indigo-400" />
              <span className="text-lg font-bold">IRSAudit</span>
            </button>
              <p className="text-gray-300 mb-4 max-w-md">
               IRS Audit Protection - Protect your business from IRS audits with our comprehensive coverage and tax attorney services.
             </p>
            <div className="flex space-x-4 mb-4">
              {/* Only include social media if links are real */}
              <a 
                href="mailto:contact@irsaudit.com" 
                className="text-gray-400 hover:text-white transition-colors"
                aria-label="Email us"
              >
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </a>
              <a 
                href="tel:1-800-IRS-AUDIT" 
                className="text-gray-400 hover:text-white transition-colors"
                aria-label="Call us"
              >
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
              </a>
            </div>
            <div className="text-gray-400 text-sm">
              <p>© {currentYear} IRS Audit Protection. All rights reserved.</p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => handleNavigate('/')} 
                  className="text-gray-300 hover:text-white transition-colors duration-200"
                >
                  Home
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigate('/intake')} 
                  className="text-gray-300 hover:text-white transition-colors duration-200"
                >
                  Get Protected
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigate('/dashboard')} 
                  className="text-gray-300 hover:text-white transition-colors duration-200"
                >
                  Dashboard
                </button>
              </li>
              <li>
                <button 
                  onClick={() => {
                    handleNavigate('/');
                    setTimeout(() => {
                      const faqSection = document.getElementById('faq');
                      if (faqSection) {
                        faqSection.scrollIntoView({ behavior: 'smooth' });
                      }
                    }, 100);
                  }} 
                  className="text-gray-300 hover:text-white transition-colors duration-200"
                >
                  FAQ
                </button>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Legal & Support</h3>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => handleNavigate('/terms')} 
                  className="text-gray-300 hover:text-white transition-colors duration-200"
                >
                  Terms of Service
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavigate('/privacy')} 
                  className="text-gray-300 hover:text-white transition-colors duration-200"
                >
                  Privacy Policy
                </button>
              </li>
              <li>
                <a 
                  href="mailto:contact@irsaudit.com" 
                  className="text-gray-300 hover:text-white transition-colors duration-200 inline-block"
                >
                  contact@irsaudit.com
                </a>
              </li>
              <li>
                <a 
                  href="tel:1-800-IRS-AUDIT" 
                  className="text-gray-300 hover:text-white transition-colors duration-200 inline-block"
                >
                  1-800-IRS-AUDIT
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8">
          <div className="text-center text-gray-400 text-sm space-y-2">
            <p>This service is not affiliated with the Internal Revenue Service (IRS).</p>
            <p>Professional tax attorney services provided by licensed professionals.</p>
            <p className="text-xs">
              By using this service, you agree to our{' '}
              <button 
                onClick={() => handleNavigate('/terms')} 
                className="underline hover:text-white"
              >
                Terms of Service
              </button>
              {' '}and{' '}
              <button 
                onClick={() => handleNavigate('/privacy')} 
                className="underline hover:text-white"
              >
                Privacy Policy
              </button>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 